<template>
  <b-card class="bg-white">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('service-partner')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Add Service Offerings</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <base-input
          alternative
          class="mb-3"
          name="Title"
          :rules="{ required: true }"
          placeholder="Title"
          v-model="title"
        >
        </base-input>

        <div class="mb-4">
          <p class="input-title text-black opacity-50">Select Categories</p>
          <b-form-select v-model="selected">
            <b-form-select-option
              v-for="option in options"
              :value="option"
              :key="option._id"
              name="Relationship"
              :rules="{ required: true }"
              >{{ option.text }}
            </b-form-select-option></b-form-select
          >
        </div>
        <quill-editor
          v-model="discription"
          :options="editorOption"
          class="quill-h200px my-2"
        />

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "./components/FileUploader.vue";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { mapState } from "vuex";
import _ from "lodash";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      title: "",
      discription: "",
      selected: [],

      editorOption: {
        theme: "snow",
      },
      options: [],
    };
  },

  methods: {
    async onSubmit() {
      //let FormData = require("form-data");
      let data = new FormData();
      data.append("title", this.title);
      data.append("categoryid", this.selected._id);
      data.append("description", this.discription);
      let loader = this.$loading();

      try {
        const blogdata = await this.$store.dispatch(
          "services/createpartner",
          data
        );
        // if (blogdata.code == 200) {
        this.$router.push({ name: "service-partner" });
        this.$swal.fire({
          text: "Service Offerings Added Successfully",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        // }
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },

    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {
    this.$store.dispatch("services/get_all");
    this.get_AllService.forEach((x) => {
      const array = this.options.push({
        text: x.title,
        _id: x._id,
      });
    });
    // console.log(this.get_AllService);
  },
  computed: {
    ...mapState("services", { get_AllService: "get_AllService" }),
  },
};
</script>
